import { useMemo } from "react";
import { useCategoryBySlugs } from "./apis/useCategoryBySlugs";

export const useSlugTitles = (categorySlugs) => {
    const { data, ...props } = useCategoryBySlugs(categorySlugs);


    const slugTitleMap = useMemo(() => {
        const slugTitleMap = {};
        if( !data?.length ){
            return slugTitleMap;
        }

        for( const category of data ){
            slugTitleMap[category.slug] = category.title;
        }
        
        return slugTitleMap;
    }, [data]);

    
    return { slugTitleMap, ...props };
}